import view from '@views/bbdoit/view';

export default {
    path: "/bbdoit/:slug",
    name: "bbdoit.view",
    component: view,
    props: true
}